/*
 * unf-header-nav.js
 * ---------------------------------------------------------------
 * Navegación del header de UNFORDS:
 *  - Cajón móvil (drawer) con acordeones y scroll propio
 *  - Mega menú de escritorio (Catálogo / Colecciones / submenús)
 *  - Carruseles horizontales (colecciones) con rueda y arrastre
 *
 * NOTA: el cajón original del tema fallaba porque era `position: fixed`
 * dentro de un #header-component con `transform` (efecto glass), lo que
 * lo dejaba atrapado y sin poder cerrarse. Aquí no se usa `fixed`: todo
 * se ancla con `position: absolute` a .header__row.
 * ---------------------------------------------------------------
 */
(function () {
  if (window.__unfHeaderNav) {
    window.__unfHeaderNav.init();
    return;
  }

  var OPEN_DELAY = 70;
  var CLOSE_DELAY = 180;

  var openTimer = null;
  var closeTimer = null;
  var currentId = null;
  var drawerOpen = false;
  var rafId = null;

  /* ---------------------------------------------------------- utils */

  function qs(sel, root) {
    return (root || document).querySelector(sel);
  }
  function qsa(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }
  function closest(el, sel) {
    return el && el.closest ? el.closest(sel) : null;
  }
  function canHover() {
    return window.matchMedia('(hover: hover) and (pointer: fine)').matches && window.innerWidth >= 990;
  }

  /* ------------------------------------------------ anclaje/CSS */

  /*
   * NOTA IMPORTANTE
   * Los paneles NO se mueven de sitio. Antes se trasladaban por JS
   * fuera del header, pero el tema vuelve a montar el header al
   * hidratarlo y deshacía el traslado, dejando el panel colgando del
   * <li>: de ahí el panel estrecho y el efecto glass perdido.
   * Ahora se quedan donde los pone Liquid y se anclan por CSS a
   * .header__row, que es `position: relative`, ocupa todo el ancho y
   * su borde inferior es el del header. Cero medidas, cero traslados.
   */

  /* ------------------------------------------------- posición top */

  /**
   * Distancia del borde inferior del header al alto del viewport.
   * Ya NO se usa para colocar los paneles (de eso se encarga
   * `top: 100%`), solo para limitar su altura máxima.
   */
  function headerBottom(header) {
    if (!header) return 0;
    return Math.max(0, Math.round(header.getBoundingClientRect().bottom));
  }

  /*
   * ══════════════════════════════════════════════════════════════
   * DOS ARREGLOS DE RENDIMIENTO EN ESTA FUNCIÓN, QUE CORRE EN CADA
   * FOTOGRAMA DE SCROLL.
   *
   * 1) DÓNDE se escribía. La variable se ponía en <html>. Las variables
   *    CSS se heredan, así que tocar una en la raíz obliga al navegador
   *    a revisar el estilo de la PÁGINA ENTERA — el header, la rejilla
   *    de productos, todo. Y --unf-nav-top solo la usan dos elementos,
   *    los dos dentro del header (el mega menú y el cajón). Poniéndola
   *    en #header-component, la revisión se queda encerrada ahí.
   *
   * 2) CUÁNTAS VECES se escribía. No había ningún freno: se reescribía
   *    en cada fotograma aunque el número fuera idéntico al anterior.
   *    Ahora solo se escribe cuando de verdad cambia.
   * ══════════════════════════════════════════════════════════════
   */
  var lastNavTop = null;
  var lastPropHost = null;

  function syncTop() {
    var header = qs('#header-component');
    if (!header) return;
    resetPropCacheIfHeaderChanged(header);

    var v = headerBottom(header);
    if (lastNavTop === v) return;
    lastNavTop = v;

    header.style.setProperty('--unf-nav-top', v + 'px');
  }

  /* Si la hidratación de Shopify reemplaza el header por un nodo nuevo,
     ese nodo llega sin las variables puestas: hay que olvidar lo
     recordado para volver a escribirlas. */
  function resetPropCacheIfHeaderChanged(header) {
    if (lastPropHost === header) return;
    lastPropHost = header;
    lastNavTop = null;
    lastGlassH = null;
  }

  /* ------------------------------------------------ cristal único */

  /*
   * UN SOLO CRISTAL PARA HEADER + DESPLEGABLE
   *
   * Dos elementos con backdrop-filter nunca se ven iguales: cada uno
   * desenfoca una región distinta y se recorta en su propio borde. Por
   * eso el panel no acababa de parecerse al header por mucho que se
   * igualaran los valores.
   *
   * Aquí solo hay uno. Se inserta dentro de #header-component, mide
   * 100dvh de alto SIEMPRE y está pintado desde que carga la página; lo
   * único que cambia es hasta dónde se recorta: la altura del header
   * cuando no hay nada abierto, y la del header más el desplegable
   * cuando sí. Header y panel son el mismo cristal, así que es imposible
   * que se vean distintos o que aparezca una costura entre los dos.
   *
   * Que la altura no cambie tampoco es un detalle: animar la altura de
   * una capa con backdrop-filter hace que Chrome deje de repintar el
   * desenfoque hasta que otra cosa invalide la pintura (mover el ratón,
   * por ejemplo). El clip-path no tiene ese problema.
   */
  function ensureGlass() {
    var header = qs('#header-component');
    if (!header || !header.hasAttribute('data-glass-mode')) {
      document.documentElement.removeAttribute('data-unf-uniglass');
      return null;
    }
    var el = qs('.unf-glass', header);
    if (!el) {
      el = document.createElement('div');
      el.className = 'unf-glass';
      el.setAttribute('aria-hidden', 'true');
      header.insertBefore(el, header.firstChild);
    }

    /* ══════════════════════════════════════════════════════════════
       EL CONTENEDOR QUE RECORTA DE VERDAD.  ← el arreglo del lag

       .unf-glass mide toda la pantalla de alto y lleva el desenfoque.
       Se "esconde" con clip-path, pero el clip-path NO es un recorte
       para el navegador: es una máscara que se aplica DESPUÉS. O sea que
       Chrome estaba desenfocando una superficie del tamaño de la
       pantalla entera y luego tapaba todo menos la franja de 60px del
       header. El trabajo se hacía igual, y se rehace en cada fotograma
       en que cambia lo que hay detrás — es decir, en cada fotograma de
       scroll de toda la tienda.

       Un `overflow: hidden` en un elemento padre sí es un recorte de
       verdad: reduce la superficie que el navegador tiene que preparar,
       no solo la que enseña. Con esto el desenfoque pasa de calcularse
       sobre ~1000px de alto a calcularse sobre los ~60px del header.

       El cristal de dentro NO se toca: mismo alto de siempre, mismo
       desenfoque, nunca se redimensiona ni se oculta. Eso es lo que
       mantiene vivo el backdrop-filter, que es el motivo por el que
       aquí nunca se pudo tocar la altura. El contenedor no lleva
       desenfoque, así que su alto sí se puede mover sin ningún riesgo.
       ══════════════════════════════════════════════════════════════ */
    var clipBox = el.parentNode;
    if (!clipBox || !clipBox.classList || !clipBox.classList.contains('unf-glass-clip')) {
      clipBox = document.createElement('div');
      clipBox.className = 'unf-glass-clip';
      clipBox.setAttribute('aria-hidden', 'true');
      header.insertBefore(clipBox, header.firstChild);
      clipBox.appendChild(el);
    }
    /* El canto (línea clara + sombra) va en un elemento aparte, sin
       recortar: el clip-path de .unf-glass corta justo en el borde y se
       comería cualquier sombra hacia fuera. Se ancla a la misma variable,
       así que hay un solo canto y se desplaza con el desplegable. */
    var edge = qs('.unf-glass-edge', header);
    if (!edge) {
      edge = document.createElement('div');
      edge.className = 'unf-glass-edge';
      edge.setAttribute('aria-hidden', 'true');
      if (clipBox.nextSibling) header.insertBefore(edge, clipBox.nextSibling);
      else header.appendChild(edge);
    } else if (edge.parentNode !== header) {
      // Nunca debe quedar dentro del contenedor recortado: su sombra
      // sale hacia fuera y se la comería el overflow.
      header.insertBefore(edge, clipBox.nextSibling);
    }
    // Solo con esta marca el CSS apaga los cristales del header y del
    // panel. Si algo falla y el elemento no llega a montarse, cada uno
    // conserva el suyo en lugar de quedarse sin fondo.
    document.documentElement.setAttribute('data-unf-uniglass', 'true');
    return el;
  }

  var lastGlassH = null;

  function syncGlass() {
    var header = qs('#header-component');
    if (!header) return;
    resetPropCacheIfHeaderChanged(header);

    /*
     * Se mide de borde a borde con getBoundingClientRect, NO con
     * offsetHeight. offsetHeight redondea a entero, y la altura real del
     * header suele ser fraccionaria (59.6px, por ejemplo): el recorte
     * caía medio píxel desviado y el navegador pintaba ahí una fila de
     * color mezclado. Esa es la línea finísima que se notaba en la unión.
     *
     * Y después se ajusta a píxeles FÍSICOS de la pantalla
     * (devicePixelRatio), para que el canto del recorte y el elemento del
     * canto caigan exactamente en el mismo píxel en pantallas retina y a
     * cualquier nivel de zoom.
     */
    var top = header.getBoundingClientRect().top;
    var open = currentOpenElement();
    var bottom = (open || header).getBoundingClientRect().bottom;

    var h = bottom - top;
    if (!(h > 0)) return;

    var dpr = window.devicePixelRatio || 1;
    h = Math.round(h * dpr) / dpr;

    /*
     * ══════════════════════════════════════════════════════════════
     * AQUI SE REINICIABA LA ANIMACION A MITAD DE CAMINO.
     *
     * --unf-glass-h es lo que mueve el recorte del cristal y el canto
     * del borde. Los dos tienen una transicion de 280 ms atada a esa
     * variable. Cada vez que se le escribe un valor NUEVO, la
     * transicion se descarta y arranca otra desde cero: 280 ms mas,
     * desde donde estuviera.
     *
     * Y esta funcion se llama dos veces seguidas al abrir (la segunda
     * en el fotograma siguiente, por si el panel crece al cargar sus
     * imagenes). Bastaba que la medida cambiara una milesima de pixel
     * — y cambia, porque se mide con decimales sobre un panel que se
     * esta revelando — para que la animacion diera un tironcito justo
     * al empezar. Eso es el "lag" que se ve en la transicion.
     *
     * Con esta tolerancia solo se reescribe si el cambio es de verdad
     * (medio pixel fisico o mas), que es el unico caso en que hay algo
     * nuevo que animar.
     * ══════════════════════════════════════════════════════════════
     */
    if (lastGlassH !== null && Math.abs(h - lastGlassH) < 0.5) return;
    lastGlassH = h;

    /* Igual que --unf-nav-top: esta variable solo la usan el cristal y su
       canto, y los dos viven DENTRO del header. Escribiéndola aquí en
       vez de en <html>, el navegador no tiene que revisar el estilo de
       toda la página cada vez que el header cambia de alto — que durante
       el scroll pasa constantemente. */
    header.style.setProperty('--unf-glass-h', h + 'px');
  }

  /*
   * Las capas del panel se sacan de `hidden` al cargar y no se vuelven a
   * ocultar: así el contenido no tiene que aparecer de golpe.
   */
  function revealLayers() {
    qsa('[data-unf-panel][hidden], [data-unf-drawer][hidden]').forEach(function (el) {
      el.hidden = false;
    });
  }

  function currentOpenElement() {
    if (drawerOpen) return qs('[data-unf-drawer]');
    if (currentId) return panelById(currentId);
    return null;
  }

  function scheduleSync() {
    if (rafId !== null) return;
    rafId = window.requestAnimationFrame(function () {
      rafId = null;
      syncTop();
      syncGlass();
    });
  }

  /* ------------------------------------------------------ mega menú */

  function panelById(id) {
    return qs('[data-unf-panel="' + id + '"]');
  }

  function setTriggerState(id, open) {
    qsa('[data-unf-trigger="' + id + '"]').forEach(function (el) {
      el.setAttribute('data-open', open ? 'true' : 'false');
      var btn = qs('[data-unf-toggle]', el);
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function openMega(id) {
    if (!id || id === currentId) return;
    if (currentId) closeMega(true);

    var panel = panelById(id);
    if (!panel) return;

    syncTop();

    // Solo por si el panel sigue oculto (JS recién cargado). A partir de
    // aquí el elemento no se vuelve a ocultar: lo que entra y sale es el
    // recorte del cristal y la visibilidad del contenido.
    if (panel.hidden) {
      panel.hidden = false;
      void panel.offsetWidth;
    }

    document.documentElement.setAttribute('data-unf-mega-open', 'true');
    currentId = id;

    panel.setAttribute('data-open', 'true');
    setTriggerState(id, true);
    syncGlass();

    // Segunda pasada: el panel puede crecer al cargar las imágenes lazy.
    window.requestAnimationFrame(function () {
      if (currentId === id) syncGlass();
    });
  }

  function closeMega(immediate) {
    if (!currentId) return;
    var id = currentId;
    var panel = panelById(id);
    currentId = null;
    setTriggerState(id, false);
    document.documentElement.removeAttribute('data-unf-mega-open');
    if (!panel) return;
    // Nunca se pone `hidden`: ocultar la capa apagaría el desenfoque y
    // volvería a tardar en aparecer en la siguiente apertura.
    panel.setAttribute('data-open', 'false');
    syncGlass();
  }

  function queueOpen(id) {
    window.clearTimeout(closeTimer);
    window.clearTimeout(openTimer);
    if (id === currentId) return;
    openTimer = window.setTimeout(function () {
      openMega(id);
    }, currentId ? 0 : OPEN_DELAY);
  }

  function queueClose() {
    window.clearTimeout(openTimer);
    window.clearTimeout(closeTimer);
    closeTimer = window.setTimeout(function () {
      closeMega();
    }, CLOSE_DELAY);
  }

  function cancelClose() {
    window.clearTimeout(closeTimer);
  }

  /* --------------------------------------------------------- drawer */

  /*
   * OJO CON EL BLOQUEO DE SCROLL
   *
   * Antes esto ponía `overflow: hidden` en el <html>. Cuando el elemento
   * raíz deja de poder desplazarse, el navegador FUERZA su scroll a 0: la
   * página saltaba arriba del todo al abrir el menú, y como el header va
   * anclado ahí, el menú aparecía en lo más alto de la tienda en vez de
   * donde estabas. Al cerrar tampoco se recuperaba la posición.
   *
   * Tampoco vale el truco de `position: fixed` en el body: el header es
   * sticky, y con el body fijado el sticky se resuelve contra su posición
   * estática y el header se iría fuera de pantalla.
   *
   * Así que no se toca el scroll de nadie. Simplemente se descarta el
   * gesto cuando ocurre FUERA del cajón. La página nunca se mueve, y
   * dentro del cajón todo (scroll vertical y carruseles) sigue igual.
   */
  function blockOutsideScroll(e) {
    if (!drawerOpen) return;
    var t = e.target;
    if (t && t.closest && t.closest('[data-unf-drawer]')) return;
    if (e.cancelable) e.preventDefault();
  }

  function lockScroll() {
    document.documentElement.setAttribute('data-unf-drawer-lock', 'true');
  }

  function unlockScroll() {
    document.documentElement.removeAttribute('data-unf-drawer-lock');
  }

  function openDrawer() {
    var drawer = qs('[data-unf-drawer]');
    if (!drawer || drawerOpen) return;
    closeMega(true);
    syncTop();
    if (drawer.hidden) {
      drawer.hidden = false;
      void drawer.offsetWidth;
    }

    drawerOpen = true;
    document.documentElement.setAttribute('data-unf-drawer-open', 'true');

    drawer.setAttribute('data-open', 'true');
    lockScroll();
    qsa('[data-unf-drawer-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'true');
    });
    syncGlass();

    window.requestAnimationFrame(function () {
      if (drawerOpen) syncGlass();
    });
  }

  function closeDrawer() {
    var drawer = qs('[data-unf-drawer]');
    drawerOpen = false;
    unlockScroll();
    qsa('[data-unf-drawer-toggle]').forEach(function (b) {
      b.setAttribute('aria-expanded', 'false');
    });
    document.documentElement.removeAttribute('data-unf-drawer-open');
    if (!drawer) return;
    drawer.setAttribute('data-open', 'false');
    syncGlass();
  }

  function toggleDrawer() {
    if (drawerOpen) closeDrawer();
    else openDrawer();
  }

  /* ----------------------------------------------------- acordeones */

  function toggleAccordion(head) {
    var item = closest(head, '[data-unf-acc]');
    if (!item) return;
    var body = qs('[data-unf-acc-body]', item);
    var isOpen = item.getAttribute('data-open') === 'true';

    if (isOpen) {
      if (body) {
        body.style.height = body.scrollHeight + 'px';
        void body.offsetWidth;
        body.style.height = '0px';
      }
      item.setAttribute('data-open', 'false');
      head.setAttribute('aria-expanded', 'false');
      return;
    }

    // Cierra hermanos (comportamiento de acordeón)
    var parent = item.parentElement;
    if (parent && parent.hasAttribute('data-unf-acc-group')) {
      qsa('[data-unf-acc][data-open="true"]', parent).forEach(function (sib) {
        if (sib === item) return;
        var sibHead = qs('[data-unf-acc-head]', sib);
        var sibBody = qs('[data-unf-acc-body]', sib);
        if (sibBody) {
          sibBody.style.height = sibBody.scrollHeight + 'px';
          void sibBody.offsetWidth;
          sibBody.style.height = '0px';
        }
        sib.setAttribute('data-open', 'false');
        if (sibHead) sibHead.setAttribute('aria-expanded', 'false');
      });
    }

    item.setAttribute('data-open', 'true');
    head.setAttribute('aria-expanded', 'true');
    if (body) {
      body.style.height = body.scrollHeight + 'px';
      window.setTimeout(function () {
        if (item.getAttribute('data-open') === 'true') body.style.height = 'auto';
        syncGlass();
      }, 320);
    }
  }

  /* --------------------------------------------- scroll horizontal */

  function bindScroller(el) {
    if (el.hasAttribute('data-unf-hs-bound')) return;
    el.setAttribute('data-unf-hs-bound', 'true');

    el.addEventListener(
      'wheel',
      function (e) {
        if (Math.abs(e.deltaY) <= Math.abs(e.deltaX)) return;
        var max = el.scrollWidth - el.clientWidth;
        if (max <= 1) return;
        var next = el.scrollLeft + e.deltaY;
        if ((next <= 0 && e.deltaY < 0) || (next >= max && e.deltaY > 0)) return;
        e.preventDefault();
        el.scrollLeft = next;
      },
      { passive: false }
    );

    var down = false;
    var startX = 0;
    var startLeft = 0;
    var moved = 0;

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'touch') return; // el táctil ya se desliza solo
      down = true;
      moved = 0;
      startX = e.clientX;
      startLeft = el.scrollLeft;
      el.setAttribute('data-dragging', 'true');
    });

    window.addEventListener('pointermove', function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 3) moved = Math.abs(dx);
      el.scrollLeft = startLeft - dx;
    });

    window.addEventListener('pointerup', function () {
      if (!down) return;
      down = false;
      el.removeAttribute('data-dragging');
      if (moved > 4) {
        el.setAttribute('data-just-dragged', 'true');
        window.setTimeout(function () {
          el.removeAttribute('data-just-dragged');
        }, 60);
      }
    });

    el.addEventListener(
      'click',
      function (e) {
        if (el.hasAttribute('data-just-dragged')) {
          e.preventDefault();
          e.stopPropagation();
        }
      },
      true
    );
  }

  /* ------------------------------------------------------ delegación */

  function bindGlobalOnce() {
    if (window.__unfHeaderNavBound) return;
    window.__unfHeaderNavBound = true;

    document.addEventListener('pointerover', function (e) {
      if (!canHover() || drawerOpen) return;
      var t = e.target;
      if (!t || !t.closest) return;
      var trigger = t.closest('[data-unf-trigger]');
      if (trigger) {
        queueOpen(trigger.getAttribute('data-unf-trigger'));
        return;
      }
      if (t.closest('[data-unf-panel]')) {
        cancelClose();
        return;
      }
      if (currentId) queueClose();
    });

    document.addEventListener('click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;

      var drawerToggle = t.closest('[data-unf-drawer-toggle]');
      if (drawerToggle) {
        e.preventDefault();
        toggleDrawer();
        return;
      }

      if (t.closest('[data-unf-drawer-close]')) {
        e.preventDefault();
        closeDrawer();
        return;
      }

      var accHead = t.closest('[data-unf-acc-head]');
      if (accHead) {
        e.preventDefault();
        toggleAccordion(accHead);
        return;
      }

      var toggle = t.closest('[data-unf-toggle]');
      if (toggle) {
        e.preventDefault();
        var host = toggle.closest('[data-unf-trigger]');
        var id = host && host.getAttribute('data-unf-trigger');
        if (!id) return;
        if (currentId === id) closeMega();
        else openMega(id);
        return;
      }

      // Un clic fuera cierra el mega menú
      if (currentId && !t.closest('[data-unf-panel]') && !t.closest('[data-unf-trigger]')) {
        closeMega();
      }

      // Al navegar desde el cajón, ciérralo
      if (drawerOpen) {
        var link = t.closest('a[href]');
        if (link && link.closest('[data-unf-drawer]')) closeDrawer();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (drawerOpen) closeDrawer();
      if (currentId) closeMega();
    });

    document.addEventListener('focusin', function (e) {
      if (!canHover() || drawerOpen) return;
      var trigger = closest(e.target, '[data-unf-trigger]');
      if (trigger) {
        queueOpen(trigger.getAttribute('data-unf-trigger'));
      } else if (currentId && !closest(e.target, '[data-unf-panel]')) {
        queueClose();
      }
    });

    document.addEventListener('touchmove', blockOutsideScroll, { passive: false });
    document.addEventListener('wheel', blockOutsideScroll, { passive: false });

    window.addEventListener('scroll', scheduleSync, { passive: true });
    window.addEventListener('resize', function () {
      syncTop();
      syncGlass();
      if (drawerOpen && window.innerWidth >= 990) closeDrawer();
      if (currentId && !canHover()) closeMega(true);
    });
    window.addEventListener('pageshow', function () {
      closeDrawer();
      closeMega(true);
    });
    document.addEventListener('shopify:section:load', function () {
      window.setTimeout(init, 0);
    });
  }

  /* ------------------------------------------------------------ init */

  function init() {
    if (!document.body) return;
    closeMega(true);
    if (drawerOpen) {
      drawerOpen = false;
      unlockScroll();
      document.documentElement.removeAttribute('data-unf-drawer-open');
    }
    syncTop();
    /* Se sacan las capas de `hidden` una sola vez y para siempre: a
       partir de aquí quedan pintadas y recortadas a cero, con el
       desenfoque ya activo. */
    revealLayers();
    ensureGlass();
    syncGlass();

    /* El header cambia de alto cuando terminan de cargar el logo y las
       tipografías. Sin estas pasadas el canto se queda donde estaba. */
    window.requestAnimationFrame(syncGlass);
    window.addEventListener('load', syncGlass, { once: true });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(syncGlass).catch(function () {});
    }

    qsa('[data-unf-hscroll]').forEach(bindScroller);
    bindGlobalOnce();
  }

  window.__unfHeaderNav = { init: init, openDrawer: openDrawer, closeDrawer: closeDrawer };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();